import FormControl from '@mui/material/FormControl';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import InputLabel from '@mui/material/InputLabel';
import OutlinedInput from '@mui/material/OutlinedInput';
import React, { ClipboardEvent, useState } from 'react';
import zeplinColor from '../../../theme/Color';

type CustomPasswordProps = {
  style?: React.CSSProperties | undefined;
  label: string;
  name: string;
  text: string;
  error?: string | boolean;
  onBlur?: (e: React.FocusEvent<any>) => void;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  tabindex?: number;
  disabled?: boolean;
};

const CustomPassword = ({
  style,
  label,
  name,
  text,
  error,
  onBlur,
  onChange,
  tabindex,
  disabled,
}: CustomPasswordProps) => {
  const handleCopyPasteCut = (event: ClipboardEvent<HTMLInputElement>) => {
    event.preventDefault();
  };

  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);

  return (
    <FormControl sx={style ? { ...style } : {}} variant='outlined'>
      <InputLabel
        htmlFor='outlined-adornment-password'
        style={{ color: disabled ? zeplinColor.Neutral6 : error ? zeplinColor.Error : '' }}
      >
        {label}
      </InputLabel>
      <OutlinedInput
        id='outlined-adornment-password'
        disabled={disabled || false}
        onCopy={handleCopyPasteCut}
        onCut={handleCopyPasteCut}
        value={text}
        error={error ? true : false}
        onBlur={onBlur}
        onChange={onChange}
        label={label}
        name={name}
        type={showPassword ? 'text' : 'password'}
        tabIndex={tabindex}
        endAdornment={
          <InputAdornment position='end'>
            <IconButton
              aria-label='toggle password visibility'
              onClick={handleClickShowPassword}
              edge='end'
            >
              {disabled ? (
                <img src='/assets/eye-closed-disabled.svg' alt='eye closed disabled' />
              ) : showPassword ? (
                <img src='/assets/eye-open.svg' alt='eye open' />
              ) : (
                <img src='/assets/eye-closed.svg' alt='eye closed ' />
              )}
            </IconButton>
          </InputAdornment>
        }
      />
      {error && (
        <p
          style={{ textAlign: 'left', color: zeplinColor.Error, fontSize: 12, margin: '0px 14px' }}
        >
          {error}
        </p>
      )}
    </FormControl>
  );
};

export default CustomPassword;
